import type { Locale } from "@/lib/i18n";
import { pl, type CDescriptivePageTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cDescriptivePageTranslations: Record<Locale, CDescriptivePageTranslations> = {
  pl,
  en,
  de,
};

export type { CDescriptivePageTranslations };
